(function () {
    "use strict";

    angular
        .module("gatewayApp")
        .controller("TrackStatusController", TrackStatusController);

    TrackStatusController.$inject = [
        "$stateParams",
        "$timeout",
        "TrackStatus",
        "$state",
        "mode",
        "CustomerRegistration",
        "$scope",
        "$rootScope",
        "CryptoUtil",
        "AlertService",
        "GlobalValues"
    ];

    function TrackStatusController(
        $stateParams,
        $timeout,
        TrackStatus,
        $state,
        mode,
        CustomerRegistration,
        $scope,
        $rootScope,
        CryptoUtil,
        AlertService,
        GlobalValues
    ) {
        var vm = this;
        vm.keyMissing = false;
        vm.activationKey = $stateParams.key;
        vm.requestId = $stateParams.requestId;
        vm.emailVerified = false;
        vm.approved = false;
        vm.tradingActivated = false;
        vm.withdrawn = false;
        vm.rejected = false;
        vm.globalValues = GlobalValues;
        vm.openCustomerDetails = openCustomerDetails;
        vm.generateOTP = generateOTP;
        vm.clicked = false;

        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";

        //updateStatus();
        viewStatus();
        function updateStatus() {
            if (
                vm.activationKey != null &&
                vm.activationKey != "" &&
                mode == "trackstatus"
            ) {
                TrackStatus.updateStatus(
                    { key: vm.activationKey },
                    onUpdateSuccess,
                    onUpdateFailure
                );
            } else {
                vm.keyMissing = true;
            }
        }

        function viewStatus() {
            var encryptedKey = CryptoUtil.encrypt($stateParams.key,GlobalValues.getPlatformENCCode());
            if (
                vm.activationKey != null &&
                vm.activationKey != "" &&
                mode == "customeronboardingstatus"
            ) {
                //TrackStatus.viewStatus({key: vm.activationKey}, onUpdateSuccess, onUpdateFailure);
                TrackStatus.viewStatus(encryptedKey,onUpdateSuccess,onUpdateFailure);
            }else if (
                vm.activationKey != null &&
                vm.activationKey != "" &&
                mode == "registrationstatus"
            ) {
                //TrackStatus.viewStatus({key: vm.activationKey}, onUpdateSuccess, onUpdateFailure);
            TrackStatus.viewStatus(encryptedKey,onUpdateSuccess,onUpdateFailure);
            
            }else {
                vm.keyMissing = true;
            }
        }

        function onUpdateSuccess(result) {
            vm.customerRegistrationRequest = result;
            vm.requestId = vm.customerRegistrationRequest.id;
            vm.requestRefNo =
                vm.customerRegistrationRequest.requestReferenceNumber;
            setStatus();
        }

        function setStatus() {
            if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "PENDINGVERIFICATION"
            ) {
                vm.emailVerified = false;
                vm.approved = false;
                vm.tradingActivated = false;
                vm.withdrawn = false;
                vm.rejected = false;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "PENDINGAPPROVAL"
            ) {
                vm.emailVerified = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "PENDINGTRADINGACTIVATION"
            ) {
                vm.emailVerified = true;
                vm.approved = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "APPROVED"
            ) {
                vm.emailVerified = true;
                vm.approved = true;
                vm.tradingActivated = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "WITHDRAWN" ||
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "WITHDRAWNBYSYSTEM"
            ) {
                vm.emailVerified = true;
                vm.withdrawn = true;
            } else if (
                vm.customerRegistrationRequest.customerBankRelationshipStatus
                    .shortName == "REJECTED"
            ) {
                vm.emailVerified = true;
                vm.rejected = true;
            }
        }

        function onUpdateFailure() {}

        // function generateOTP(){
        //     CustomerRegistration.sendOTPForRequestRefNo({requestReferenceNo: vm.requestRefNo}, onValidateSuccess, onValidateFailure);
        // }

        function generateOTP() {
            // ✅ Step 1: Execute reCAPTCHA
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey,vm.globalValues.getPlatformENCCode()), {
                        action: "otp_action"
                    })
                    .then(function (token) {
                       // console.log("reCAPTCHA token:", token);

                        // ✅ Step 2: Call API with token
                        CustomerRegistration.sendOTPForRequestRefNo(
                            {
                                requestReferenceNo: vm.requestRefNo,
                                recaptchaToken: token,
                                sourceType: "send-otp",
                                source: "view-registartion-request"
                            },
                            onValidateSuccess,
                            onValidateFailure
                        );
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA error:", error);

                        vm.disableGenerateUserOTP = false;
                        vm.showGenerateUserOTPButton = true;
                    });
            });
        }

        function onValidateSuccess(result) {
            if (mode == "registrationstatus") {
                $state.go("otp-confirmation-fetch-reg-request", {
                    refNo: vm.requestRefNo,
                    theme: "light"
                });
                vm.clicked = false;
            } else if (mode == "customeronboardingstatus") {
                $state.go("otp-confirmation-fetch-request", {
                    refNo: vm.requestRefNo,
                    theme: "light"
                });
                vm.clicked = false;
            }
        }

        function onValidateFailure() {
            vm.clicked = false;
        }

        var subscribeFetchRegisteredRequest = $rootScope.$on(
            "fetchRegisteredRequest",
            function (event, result) {
                openCustomerDetails();
            }
        );

        $scope.$on("$destroy", function () {
            $timeout(function () {
                subscribeFetchRegisteredRequest();
            }, 500);
        });

        function openCustomerDetails() {
            vm.cryptActivityKey = CryptoUtil.encrypt(
                vm.activationKey,
                vm.platformENCCode
            );
            if (mode == "trackstatus") {
                $state.go("customer-track-status-view", {
                    id: vm.cryptActivityKey,
                    theme: "light"
                });
            } else if (mode == "registrationstatus") {
                $state.go("customer-registration-status-view", {
                    id: vm.cryptActivityKey,
                    theme: "light"
                });
            } else if (mode == "customeronboardingstatus") {
                $state.go("customer-onboarding-status-view", {
                    id: vm.cryptActivityKey,
                    theme: "light"
                });
            }
        }
    }
})();
